import { Record, Map } from "immutable";

import { Album, Artist, Track, MusicNormalisedEntities } from "@music/models";

export const ChartStreamTracksWeek = "stream-tracks-week";
export const ChartStreamTracksAllTime = "stream-tracks-alltime";
export const ChartDownloadTracksWeek = "download-tracks-week";
export const ChartDownloadTracksAllTime = "download-tracks-alltime";
export const ChartDownloadAlbumsWeek = "download-albums-week";
export const ChartDownloadAlbumsAllTime = "download-albums-alltime";
export const ChartStreamArtistsPeriod = "stream-artists-period";
export const ChartPreordersPeriod = "preorders-period";
export type ChartName = "stream-tracks-week" | "stream-tracks-alltime" |
    "stream-tracks-period" | "download-tracks-week" | "download-tracks-alltime" |
    "download-tracks-period" | "download-albums-week" | "download-albums-alltime" |
    "download-albums-period" | "stream-newreleases-period" | "stream-artists-period";

interface ChartRowStreams {
    total: number;
    vendor?: {
        [key: string]: number;
    };
}

export interface IChart {
    name?: ChartName;
    rows?: IChartRow[];
}

export interface IChartRow {
    isrc?: string;
    upc?: string;
    albumId?: number;
    trackId?: number;
    artistId?: number;
    streams?: ChartRowStreams;
    album?: Album;
    track?: Track;
    artist?: Artist;
}

const ChartRecord = Record({
    name: undefined,
    rows: [],
});

const ChartRowRecord = Record({
    isrc:     undefined,
    upc:      undefined,
    albumId:  undefined,
    trackId:  undefined,
    artistId: undefined,
    album:    undefined,
    track:    undefined,
    artist:   undefined,
    streams:  undefined,
});

export class Chart extends ChartRecord implements IChart {
    public name: ChartName;
    public rows: ChartRow[];

    constructor(params?: IChart) {
        // Create the rows.
        if (params && "rows" in params) {
            const rowObjs: ChartRow[] = [];
            for (const row of params.rows) {
                rowObjs.push(new ChartRow(row));
            }
            params.rows = rowObjs;
        }

        super(params);
    }

    public isNewReleasesChart(): boolean {
        return this.name === "stream-newreleases-period";
    }
}

export class ChartRow extends ChartRowRecord implements IChartRow {
    public isrc: string;
    public upc: string;
    public albumId: number;
    public trackId: number;
    public artistId: number;
    public album: Album;
    public track: Track;
    public artist: Artist;
    public streams: ChartRowStreams;
}

export interface ChartsInternalState {
    items: Map<string, Chart>;
    lastLoaded: Date;
}

export interface ChartsState {
    charts: ChartsInternalState;
}

export interface ChartsNormalisedEntities extends MusicNormalisedEntities {
    charts?: Map<string, Chart>;
}

export const isChartDownload = (name: string): boolean => name.includes("download") || name.includes("preorder");
export const isChartStream = (name: string): boolean => name.includes("stream");
export const getChartType = (name: string): "stream" | "download" => name.includes("stream") ? "stream" : "download";
